<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body">
			<div class="center">
				<div class="ucenter_main">
					<ucMenu num="8"></ucMenu>
					<div class="right_con">
						<div class="bind_main">
							<!-- <p class="fb" >统一运费配置</p>
							<p class="list_wrap" style="width: 60%;"><el-input class="in" placeholder="请输入统一运费金额" v-model="freight_price"><button class="el-button" size="mini" slot="append" @click="postFreightPrice">（元）修改</button></el-input></p> -->
							
							<!-- <p class="add_btn" @click="showbindy()">添加绑定</p> -->
							<p class="fb" style="margin-top: 20px;">绑定物流合作网点</p>
							<!-- <p class="exp">请选择已线下签约过的快递公司/网点，输入签约时分配给你的账号和密码，提交绑定，用于后续打单发货。</p> -->
							<div class="list_wrap" v-if="list.length > 0">
								<div class="list_item" v-for="(item,index) in list" :key="index">
									<!-- <el-descriptions :title="item.logistics_company.name" :column="1">
											<el-descriptions-item label="备注名" label-class-name="my-label">{{item.remark_name}}</el-descriptions-item>
											<el-descriptions-item v-if="item.customer_name" label="账号" label-class-name="my-label">{{item.customer_name}}</el-descriptions-item>
											<el-descriptions-item v-if="item.month_code" label="月结号" label-class-name="my-label">{{item.customer_name}}</el-descriptions-item>
											<el-descriptions-item v-if="item.send_site" label="归属网点" label-class-name="my-label">{{item.send_site}}</el-descriptions-item>
											<el-descriptions-item label="邮编" label-class-name="my-label">{{item.post_code}}</el-descriptions-item>
											<el-descriptions-item label="发货人" label-class-name="my-label">{{item.name}}</el-descriptions-item>
											<el-descriptions-item label="手机号" label-class-name="my-label">{{item.mobile}}</el-descriptions-item>
											<el-descriptions-item label="发货地址" label-class-name="my-label" content-class-name="my-content">{{item.province_name}}{{item.city_name}}{{item.exp_area_name}}{{item.address}} </el-descriptions-item>
											<el-descriptions-item label="" label-class-name="my-label" content-class-name="my-content">
												<div class="item_btn_wrap">
													<el-link class="item_btn" type="primary">修改</el-link>
													<el-link class="item_btn" type="danger">删除</el-link>
													<i class="icon el-icon-delete" @click="del(item.id)"></i>
												</div>
											</el-descriptions-item>
									</el-descriptions> -->
									<el-descriptions :title="item.logistics_company.name" :column="1">
											
											<el-descriptions-item label="快递公司" label-class-name="my-label">{{item.logistics_company.name}}</el-descriptions-item>
											<el-descriptions-item label="面单余额" label-class-name="my-label">{{item.amount}}</el-descriptions-item>
											<el-descriptions-item label="网点名称" label-class-name="my-label">{{item.netsite_name}}</el-descriptions-item>
											</el-descriptions-item>
											<el-descriptions-item></el-descriptions-item>
											<el-descriptions-item label="" label-class-name="my-label" content-class-name="my-content">
												<div class="item_btn_wrap" v-if="item.is_default!=1">
													<!-- <el-link class="item_btn" type="primary" @click="setDefault(item.id)">设为默认</el-link> -->
													<el-popover
													  placement="top"
													  width="200"
													  v-model="set_default_model">
													  <p>选择发货地址</p>
														<br>
														<el-select size="mini" class="w100" v-model="address_index" placeholder="请选择" clearable>
															<el-option v-for="(a,a_index) in item.sender_address" :key="a_index" :label="a.province_name+a.city_name+a.district_name+a.detail_address" :value="a_index">
															</el-option>
														</el-select>
														<br><br>
													  <div style="text-align: right; margin: 0">
													    <el-button size="mini" type="info" @click="set_default_model = false">取消</el-button>
													    <el-button type="primary" size="mini" @click="setDefault(item.id)">确定</el-button>
													  </div>
													  <el-link class="item_btn" slot="reference" type="primary">设为默认</el-link>
													</el-popover>
												</div>
												<div class="item_btn_wrap" v-else>
													<el-link class="item_btn" type="info" @click="setDefault(0)">取消默认</el-link>
												</div>
											</el-descriptions-item>
									</el-descriptions>
								</div>
							</div>
							<el-empty v-if="list.length == 0" description="未绑定物流合作网点,请联系客服绑定"></el-empty>
							
						</div>
						
					</div>
				</div>
			</div>
		</div>
		<!-- 绑定网点弹窗 -->
		<el-dialog title="添加绑定" :visible.sync="dialog.bindDialog" width="20%" center >
			<bindLogistics @close="dialog.bindDialog = false" @success="init()" :isLoading.sync="is_loading" :show.sync="dialog.bindDialog"></bindLogistics>
		</el-dialog>
		<myFoot></myFoot>
	</div>
</template>

<script>
import Vue from 'vue';
import { mapActions,mapState } from "vuex";
import myHead from '../../components/myHead/myhead';
import myFoot from '../../components/myFoot/myfoot';
import ucMenu from '../../components/ucenterMenu/ucmenu';
import common from '../../assets/js/utils/common';
import bindLogistics from '../../components/bindLogistics/bindLogistics';
import {supplierRegionList} from "../../api/main/ucenter.js";
export default {
	name: "ucenterLogistics",
	data() {
		return {
			is_loading:false,
			dialog: {
				bindDialog:false,
			},
			list: [],
			freight_price: '',
			set_default_model: false,
			address_index: ''
		}
	},
	components:{
		myHead,myFoot,ucMenu,bindLogistics
	},
	
	created(){
		this.init()
	},
	methods: {
		...mapActions({
			getSupplierKdnLcb:"ucenter/getSupplierKdnLcb",
			opDelBindLogisticsCompany:"ucenter/opDelBindLogisticsCompany",
			opEditFreightPrice:"ucenter/opEditFreightPrice",
			opSetDefaultNetsite:"ucenter/opSetDefaultNetsite",
		}),
		init(){
			
			this.is_loading = true
			this.getSupplierKdnLcb({data:{},success:(res)=>{
				// console.log('getSupplierKdnLcb',res)
				if(res.code == 200){
						this.list = res.data.list
						this.freight_price = res.data.freight_price
				}
			}})
		},
		del(lcb_id){
			var that = this
			this.is_loading = true
			that.$confirm('确认删除该记录?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				that.opDelBindLogisticsCompany({data:{lcb_id:lcb_id},success:(res)=>{
					if(res.code == 200){
							that.init()
					}else{
						that.$message({
							type: 'error',
							message: res.msg
						})
					}
				}})
			}).catch((res) => {
				console.log(res)
			});
			
		},
		//修改供应商统一运费
		postFreightPrice(){
			this.opEditFreightPrice({data:{freight_price:this.freight_price},success:(res)=>{
				if(res.code == 200){
						this.$message({
							type: 'success',
							message: res.msg
						})
				}else{
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			}})
		},
		showbindy(){
			this.dialog.bindDialog = true
		},
		//设置默认网点
		setDefault(id){
			let addr_idx = this.address_index
			if(id != 0){
				addr_idx = this.address_index
				if(addr_idx === ''){
					this.$message({type:'warning',message:'请选择发货地址'})
					return
				}
			}
			this.opSetDefaultNetsite({data:{id:id,addr_idx:addr_idx},success:(res)=>{
				if(res.code == 200){
						this.$message({
							type: 'success',
							message: res.msg
						})
				}else{
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
				this.set_default_model = false
				this.address_index = ''
				this.init()
			}})
		}
	}
}
</script>

<style>
.wrap .wrap_body{display: flex;flex-direction: column;}
.center{display: flex;flex: 1;}
.ucenter_main{padding: 30px 0 40px;display: flex;justify-content: space-between;flex: 1;}

.right_con{width: 980px;background: #fff;}
.bind_main{padding: 36px 40px;position: relative;}
.bind_main .add_btn{width: 74px;height: 32px;box-sizing: border-box;border: 1px solid var(--red);display: flex;justify-content: center;align-items: center;cursor: pointer;color: var(--red);font-size: 14px;margin-right: 20px;margin-top: 20px;position: absolute;right: 30px;top: 26px;}
.bind_main .exp{font-size: 12px;color: #999;margin-top: 10px;}
.bind_main .list_wrap{margin-top: 20px;}
.bind_main .list_wrap .list_item{display: inline-block;width: 29.2%;border: 1px solid #ccc;border-radius: 2px;padding: 10px 15px 0;margin-right: 2%;margin-top: 20px;box-sizing: border-box;}
.bind_main .list_wrap .list_item:nth-child(3n){margin-right: 0;}
.bind_main .list_wrap .list_item .item_btn_wrap{text-align: right;}
.bind_main .list_wrap .list_item .item_btn_wrap .item_btn{margin-right: 10px;}
.el-descriptions :not(.is-bordered) .el-descriptions-item__cell{padding-bottom: 5px !important;}
.bind_main .list_wrap .list_item .item_btn_wrap .icon{cursor: pointer;color: #999;}
.my-label{width: 27%;margin-right: 10px !important;color: #999;}
.el-descriptions-item__label.has-colon::after{display: none;}
.my-content{width: 70%;display: flex;justify-content: flex-end;overflow: hidden;	text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;	line-clamp: 2;-webkit-box-orient: vertical;}
.el-descriptions__header{margin-bottom: 10px;}
</style>
<style>
.bind_main .el-input--prefix .el-input__inner, .bind_main .el-cascader .el-input .el-input__inner, .el-input--prefix .el-input__inner, .bind_main .el-cascader .el-input .el-input__inner{height: 38px !important;}
.bind_main .el-cascader{width: 400px !important;}
.bind_main .el-cascader .el-input .el-input__inner::placeholder{color: #606266;}
.bind_main .el_input{margin: 14px 0 0 !important;}
.bind_main .el-input--prefix .el-input__inner,.bind_main .el-cascader .el-input .el-input__inner{padding-left: 76px;height: 34px;line-height: 34px;}

.bind_main .el_input{display: flex;margin: 12px 0 0;width: initial;}
.bind_main .el_input .el-input__inner{height: 38px;line-height: 38px;padding-left: 58px;flex: 1;width: 0;}
.bind_main .el_input.el_sel .el-input__inner{width: 100%;}
.bind_main .el_input .el-input__inner:focus , .el-select .el-input.is-focus .el-input__inner{border-color: var(--red);}
.el-select-dropdown__item.selected{color: var(--red);}
.bind_main .el_input.el_in2 .el-input__inner{padding-left: 110px;}
.bind_main .el_input.el_in3 .el-input__inner{padding-left: 85px;}
.bind_main .el_input .el-input__prefix{line-height: 38px;}
.bind_main .el_input .el-input__prefix .icons{width: 38px;height: 36px;display: flex;justify-content: center;align-items: center;top: 1px;left: 2px;background: #f5f5f5;border-right: 1px solid #ddd;border-radius: 4px 0 0 4px;}
.bind_main .el_input .el-input__prefix .icons .iconfont{font-size: 20px;color: #cccccc;}
.bind_main .el_input .el-input__prefix .txts{width: 100%;height: 100%;display: flex;align-items: center;color: #999;padding-left: 10px;}
.bind_main .el_input .el-input__suffix{display: flex;}
.bind_main .el_input .el-input__suffix .el-input__suffix-inner{display: flex;align-items: center;line-height: 38px;}
.bind_main .el_input .el-input__suffix .el-input__suffix-inner .getcode{font-size: 14px;color: #333333;padding: 0 12px;border-left: 1px solid #ccc;line-height: 1;cursor: pointer;}
.el-descriptions :not(.is-bordered) .el-descriptions-item__cell{padding-bottom: 20px;}
.el-descriptions-item__label:not(.is-bordered-label){margin-right: 30px;}
.el-input--prefix .el-input__inner,.el-cascader .el-input .el-input__inner{padding-left: 76px;height: 34px !important;line-height: 34px;}

/*red border color*/
.el-button.is-plain:focus, .el-button.is-plain:hover ,.el-checkbox__inner:hover ,.el-checkbox__input.is-focus .el-checkbox__inner,.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner, .el-pagination__jump .el-input__inner:focus,.el-cascader .el-input .el-input__inner:focus,.el-cascader .el-input .el-input__inner:focus, .el-cascader .el-input.is-focus .el-input__inner{border-color: var(--red);}

/*red color*/ 
.el-button.is-plain:focus, .el-button.is-plain:hover, .el-checkbox__input.is-checked+.el-checkbox__label, .el-pager li.active ,.el-pagination button:hover ,.el-pager li:hover{color: var(--red);}

/*red background color*/
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{background-color: var(--red);}

.el-button:focus, .el-button:hover{border-color: var(--red);color: var(--red);background:#fff;}
.el-button--primary{background: var(--red) !important;color: #fff !important;border-color: #fff;}
.el-button--primary:focus, .el-button:hover{border-color: var(--red);}
.el-loading-spinner .el-loading-text{color:var(--red);}
.el-loading-spinner .path{stroke: var(--red);}
.el-select .el-input.is-focus .el-input__inner ,.el-select .el-input__inner:focus{border-color: var(--red);}
.el-select-dropdown__item.selected,.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path{color: var(--red);}
.el-descriptions-item__container .el-descriptions-item__content{white-space: nowrap;overflow: hidden;text-overflow: ellipsis;display: block;}
</style>
